import React, { Component } from 'react';
import { HashRouter, Route, Switch,Redirect } from 'react-router-dom';
import './App.css';
// Styles
// CoreUI Icons Set
import '@coreui/icons/css/coreui-icons.min.css';
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import './scss/style.scss'
import WSManager from "./helper/WSManager";
// Containers
import { DefaultLayout } from './containers';
import { Login, Page401, Page404, Page500, Register } from './views/Pages';
// import VerifyFantasyDomain from './views/Common/VerifyFantasyDomain';

// import { renderRoutes } from 'react-router-config';

class App extends Component {
  render() {

    const PrivateRoute = ({ component: Component, ...rest }) => (
      <Route {...rest} render={(props) => (
          WSManager.loggedIn() == true
              ? <Component {...props} />
              : <Redirect to={{
                  pathname: '/login',
                  state: { from: props.location }
              }} />
              
      )} />
  )
    return (
      <HashRouter>
        <Switch>
        <Route exact path="/login" name="Login Page" component={Login} />
          {/* <Route exact path="/register" name="Register Page" component={Register} /> */}
          <Route exact path="/401" name="Page 401" component={Page401} />
          <Route exact path="/404" name="Page 404" component={Page404} />
          <Route exact path="/500" name="Page 500" component={Page500} />
          <PrivateRoute path="/" name="Home" component={DefaultLayout} />
          {/* <Route path="/verify-fantasy-domain/:key" name="VerifyFantasyDomain" component={VerifyFantasyDomain} /> */}
        </Switch>
      </HashRouter>
    );
  }
}

export default App;
